import { css } from "@linaria/core";

import { pm2Header } from "@pm2/design-tokens";

export const wrapperCls = css`
  --library--top: ${pm2Header.height.computed()};

  flex-grow: 1;
`;
